import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const ArticleDek = ({
  dek,
  hasNoImage,
  isShoppingSection,
}) => (
  <div
    className={classNames(
      'article-dek',
      {
        'article-dek__with-image': !hasNoImage,
        'article-dek__shopping-section': isShoppingSection,
        'article-dek__no-image': hasNoImage,
      },
    )}
  >
    {dek}
  </div>
);

ArticleDek.propTypes = {
  dek: PropTypes.string.isRequired,
  hasNoImage: PropTypes.bool,
  isShoppingSection: PropTypes.bool,
};

ArticleDek.defaultProps = {
  hasNoImage: false,
  isShoppingSection: false,
};

export default ArticleDek;
